import { makeStyles } from 'tss-react/mui';

const name = 'Timeframes';

export const useTimeframesStyles = makeStyles({ name })(theme => ({
  root: {
    '&&': {
      borderRadius: theme.shape.borderRadiusMd, // ex 17
    },
  },
  tab: {
    '&&': {
      borderRadius: theme.shape.borderRadius, // ex 15,
    },
  },
}));
